/**
 * Site naming in the header. Rolls live under `public/photos/<folder>/roll.yaml`;
 * see `templates/photo-roll/` for a starter file. Manifest: `npm run photos:manifest`
 * (runs before dev/build).
 */

export const site = {
  /** Shown in the page header (browser tab title is in index.html). */
  title: 'Vinayak Kapoor',
  tagline: 'Film Photography',
};

/** @typedef {{ alt: string, caption?: string, src?: string, tone?: string }} Frame */
/** @typedef {{ id: string, title: string, frames: Frame[] }} Collection */
